import { render, staticRenderFns } from "./TicketComponent.vue?vue&type=template&id=30699988"
import script from "./TicketComponent.vue?vue&type=script&lang=js"
export * from "./TicketComponent.vue?vue&type=script&lang=js"
import style0 from "./TicketComponent.vue?vue&type=style&index=0&id=30699988&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports